import { render, staticRenderFns } from "./FindingsSection.vue?vue&type=template&id=482ba59a"
import script from "./FindingsSection.vue?vue&type=script&lang=js"
export * from "./FindingsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports